import { NdbxIconModule } from '@allianz/ngx-ndbx/icon';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NxAccordionModule } from '@aposin/ng-aquila/accordion';
import { NxErrorModule } from '@aposin/ng-aquila/base';
import { NxButtonModule } from '@aposin/ng-aquila/button';
import { NxCardModule } from '@aposin/ng-aquila/card';
import { NxCheckboxModule } from '@aposin/ng-aquila/checkbox';
import { NxContextMenuModule } from '@aposin/ng-aquila/context-menu';
import { NxCopytextModule } from '@aposin/ng-aquila/copytext';
import { NxDatefieldModule } from '@aposin/ng-aquila/datefield';
import { NxDropdownModule } from '@aposin/ng-aquila/dropdown';
import { NxFileUploaderModule } from '@aposin/ng-aquila/file-uploader';
import { NxFormfieldModule } from '@aposin/ng-aquila/formfield';
import { NxGridModule } from '@aposin/ng-aquila/grid';
import { NxHeaderModule } from '@aposin/ng-aquila/header';
import { NxHeadlineModule } from '@aposin/ng-aquila/headline';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import { NxInputModule } from '@aposin/ng-aquila/input';
import { NxIsoDateModule } from '@aposin/ng-aquila/iso-date-adapter';
import { NxLinkModule } from '@aposin/ng-aquila/link';
import { NxListModule } from '@aposin/ng-aquila/list';
import { NxMaskModule } from '@aposin/ng-aquila/mask';
import { NxMessageModule } from '@aposin/ng-aquila/message';
import { NxDialogService, NxModalModule } from '@aposin/ng-aquila/modal';
import { NxNumberStepperModule } from '@aposin/ng-aquila/number-stepper';
import { NxPhoneInputModule } from '@aposin/ng-aquila/phone-input';
import { NxRadioModule } from '@aposin/ng-aquila/radio-button';
import { NxSpinnerModule } from '@aposin/ng-aquila/spinner';
import { NxSwitcherModule } from '@aposin/ng-aquila/switcher';
import { NxTableModule } from '@aposin/ng-aquila/table';
import { NxTabsModule } from '@aposin/ng-aquila/tabs';
import { NxTaglistModule } from '@aposin/ng-aquila/taglist';
import { NxTooltipModule } from '@aposin/ng-aquila/tooltip';
import { NxTreeModule } from '@aposin/ng-aquila/tree';

// @INFO
// Keep it in alphabetical order
const NDBX_MODULES = [
  NxAccordionModule,
  NxButtonModule,
  NxCardModule,
  NxCheckboxModule,
  NxCopytextModule,
  NxDatefieldModule,
  NxDropdownModule,
  NxErrorModule,
  NxFormfieldModule,
  NxGridModule,
  NxHeadlineModule,
  NxIconModule,
  NxInputModule,
  NxIsoDateModule,
  NdbxIconModule,
  NxLinkModule,
  NxListModule,
  NxMessageModule,
  NxMaskModule,
  NxModalModule,
  NxNumberStepperModule,
  NxPhoneInputModule,
  NxRadioModule,
  NxSpinnerModule,
  NxSwitcherModule,
  NxTabsModule,
  NxTaglistModule,
  NxTooltipModule,
  NxFileUploaderModule,
  NxTableModule,
  NxHeaderModule,
  NxContextMenuModule,
  NxTreeModule,
];

@NgModule({
  declarations: [],
  imports: [CommonModule, ...NDBX_MODULES],
  exports: [...NDBX_MODULES],
  providers: [NxDialogService],
})
export class NdbxModule {}
